'use client';

import { PublicProvider } from '@/contexts/PublicContext';
import ErrorBoundary from '@/components/ErrorBoundary';

export default function CareersLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ErrorBoundary>
      <PublicProvider>{children}</PublicProvider>
    </ErrorBoundary>
  );
}
